import { __decorate } from "tslib";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
export let SubscriberComponent = class SubscriberComponent {
    ngUnsubscribe = new Subject();
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    cleanupAfterDestroy(observable) {
        return observable.pipe(takeUntil(this.ngUnsubscribe));
    }
};
SubscriberComponent = __decorate([
    Component({
        template: "",
        host: { 'SubscriberComponent': 'aflaportal-application' },
        changeDetection: ChangeDetectionStrategy.OnPush
    })
], SubscriberComponent);
